







import { Component, Vue } from 'vue-property-decorator';
import ModalIframe from '@/components/iframe/ModalIframe.vue';
import { logout } from '@/utils/token';

@Component({ components: { ModalIframe } })
export default class DuplicateLoginCheckPopup extends Vue {
  private concurrent: boolean | null = null;

  private get layerPopupStyle() {
    if (!this.concurrent) {
      return { width: '0px', height: '0px', padding: '0px', border: 'none', overflow: 'hidden' };
    }
    return { maxHeight: '480px', width: '600px', padding: '0px', border: 'none' };
  }

  private get remoteSrc() {
    const queryObject = { serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/duplicate-login-check?' + queryString;
  }

  private async receiveMessage(e: MessageEvent) {
    if (!e.data.type?.includes('DUPLICATE_LOGIN__')) {
      return;
    }

    if (e.data.type === 'DUPLICATE_LOGIN__CONCURRENT') {
      this.concurrent = e.data.concurrent;

      if (this.concurrent === false) {
        this.$emit('nextAfterDuplicateLoginCheck');
      }

      return;
    }

    if (e.data.type === 'DUPLICATE_LOGIN__LOGOUT' && e.data.logout) {
      await logout(true);
      this.$emit('closePopup');

      return;
    }

    if (e.data.type === 'DUPLICATE_LOGIN__SUCCESS_LOGIN' && e.data.successLogin) {
      this.$emit('closePopup');
      this.$emit('nextAfterDuplicateLoginCheck');

      return;
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
